import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from '../components/home/home.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';
import { AuthenticationGuardService } from '../services';
import { TableauComponent } from '../components/tableau/tableau.component';

const routes: Routes = [
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent , canActivate: [AuthenticationGuardService]},
  { path: 'tableau', component: TableauComponent , canActivate: [AuthenticationGuardService]},

  { path: 'forbidden', component: UnauthorizedComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },

  { path: '**', redirectTo: '/home'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
